import { gql } from '@apollo/client'

export const GET_HERMANOTYPES = gql`
query GetHermanoTypes {
    getHermanoTypes {
        Name
        Priority
    }
}
`